import { render } from "./PixBankNotice.vue?vue&type=template&id=0173f0e3&scoped=true"
import script from "./PixBankNotice.vue?vue&type=script&lang=js"
export * from "./PixBankNotice.vue?vue&type=script&lang=js"

import "./PixBankNotice.vue?vue&type=style&index=0&id=0173f0e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0173f0e3"]])

export default __exports__